// extracted by mini-css-extract-plugin
module.exports = {"root":"c5DdvdS","header":"T6buvX","title":"eEk7ON","list":"c5MaDvf"};